// extracted by mini-css-extract-plugin
module.exports = {"pagination":"style_pagination__Xuyv3","active":"style_active__2MkaL","switch":"style_switch__3K-Cx","switcher":"style_switcher__vuI8J"};